import type { QueryClient } from "@tanstack/react-query";
import { PrivatesAppointmentsApi } from "@/openapi/generated";
import { createAuthenticatedApi } from "@/lib/utils";
import { appointmentBookingsQueryKey } from "@/features/appointments/utils/appointment-bookings-query";

export async function prefetchAppointmentBookingsGet(
  appointmentId: number,
  queryClient: QueryClient,
  accessToken?: string,
) {
  if (!accessToken) {
    throw new Error("Access token is required for prefetching appointment bookings");
  }

  const service = createAuthenticatedApi(PrivatesAppointmentsApi, accessToken);

  await queryClient.prefetchQuery({
    queryKey: appointmentBookingsQueryKey(appointmentId),
    queryFn: () =>
      service.apiAppointmentsIdBookingsGet({
        id: appointmentId,
      }),
    staleTime: 30 * 1000,
  });

  return queryClient;
}

